// extracted by mini-css-extract-plugin
module.exports = {"ErrorMessage":"select_ErrorMessage__3n8VC"};